export const triggerDynatraceEvent = (eventType: any, eventName: string) => {
  const id =
    (window as Window).dtrum?.enterAction(
      eventName,
      'custom',
      (window as Window).dtrum?.now(),
    ) || 0;

  (window as Window).dtrum?.addActionProperties(
    id,
    undefined,
    undefined,
    eventType,
  );

  (window as Window).dtrum?.leaveAction(id, (window as Window).dtrum?.now());
};
